/**
 * Wrap the contents of .pagination-container .pagination .page-item .page-link in a span
 */
document.addEventListener('DOMContentLoaded', function() {
  function wrapPageLinkContents() {
    const pageLinks = document.querySelectorAll('.pagination-container .pagination .page-item .page-link');
    pageLinks.forEach(link => {
      // Create a span and add the "page-link-text" class
      const span = document.createElement('span');
      span.classList.add('page-link-text');
      // Move all child nodes into the span
      while (link.firstChild) {
        span.appendChild(link.firstChild);
      }
      link.appendChild(span);
    });
  }

  wrapPageLinkContents();
});
